import { useAuth } from '../context/AuthContext';
import { OPS_ITEMS, canSeeItem } from '../menuConfig';

// Màn "Vận hành" của thanh điều hướng mobile (thay tab KPI cho nhân sự Phòng OP): liệt kê các chức
// năng vận hành để bấm 1 phát là vào. Mở từ đây thì màn con có nút back quay lại chính màn này
// (App.jsx truyền onBack — xem setPage(key, 'ops')).
const TINT = '#00853c'; // màu nhóm VẬN HÀNH, khớp GROUP_META bên MobileMenuPage

export default function MobileOpsPage({ setPage }) {
  const { me } = useAuth();
  const items = OPS_ITEMS.filter((i) => canSeeItem(me, i));

  return (
    <div className="page mbmenu">
      <div className="page-head">
        <div>
          <h2>Vận hành</h2>
          <div className="sub">Chọn chức năng kho / giao hàng</div>
        </div>
      </div>

      {items.length ? (
        <div className="mbmenu-sec">
          {items.map((i) => (
            <button key={i.key} type="button" className="mbmenu-row" onClick={() => setPage(i.key, 'ops')}>
              <span className="mbmenu-row-ico" style={{ color: TINT, background: `color-mix(in srgb, ${TINT} 12%, transparent)` }}>
                <i className={`ti ${i.ico}`} />
              </span>
              <span className="mbmenu-row-label">{i.label}</span>
              <i className="ti ti-chevron-right mbmenu-chev" />
            </button>
          ))}
        </div>
      ) : (
        <div className="empty">Tài khoản của bạn chưa có chức năng vận hành nào.</div>
      )}
    </div>
  );
}
